import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import MRNMDCreate from "./ManufacturingDomestic/Create";
import PICreate from "./PumpSpareInternational/Create";

function MRNCreate() {
  const [mrntype, setmrntype] = useState("");
  const [mrncategory, setmrncategory] = useState("");
  const [mrntypeDisabled, setmrntypeDisabled] = useState(false);
  const [mrncategoryDisabled, setmrncategoryDisabled] = useState(false);

  const handlemrntypeChange = (event) => {
    const selectedmrntype = event.target.value;
    setmrntype(selectedmrntype);
    setmrncategory(""); // Reset PO category
    setmrncategoryDisabled(false);
    setmrntypeDisabled(true);

    if (selectedmrntype === "Manufacturing") {
      setmrncategory("Domestic");
      setmrncategoryDisabled(true);
    }
    if (selectedmrntype === "Pump Spare") {
      setmrncategory("International");
      setmrncategoryDisabled(true);
    }
  };

  const PageDisplay = () => {
    if (mrntype === "Pump Spare" && mrncategory === "International") {
      return <PICreate />;
    }
    if (mrntype === "Manufacturing") {
      return <MRNMDCreate />;
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD GRN</h6>
          <Link to="/mrnindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select
                  onChange={handlemrntypeChange}
                  value={mrntype}
                  disabled={mrntypeDisabled}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Pump Spare">Pump Spare</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {mrntype && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value={mrncategory} disabled />
                </Form.Group>
              </Col>
            )}
            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default MRNCreate;
